import { Controller } from '@hotwired/stimulus';
import { Tabulator } from 'tabulator-tables';
// import Tabulator from '../../../../../public/tabulator-tables/dist/js/tabulator.min.js';

export default class extends Controller {
  static targets = ['table'];

  static values = {
    tabulatorTable: Object, // store reference to table
  };

  connect() {
    const dataSource = this.data.get('dataSource');
    const columns = this.data.get('columns');
    const config = this.data.get('config');

    const defaultConfig = {
      layout: 'fitDataStretch',
      pagination: false,
      data: dataSource || null,
      autoColumns: !columns,
      columns: columns ? JSON.parse(columns) : [],
      // renderHorizontal: 'virtual',
      // responsiveLayout: true,
    };

    const configOptions = config ? JSON.parse(config) : null;
    if (config && dataSource) {
      configOptions.data = dataSource;
    }
    if (config && columns) {
      configOptions.columns = JSON.parse(columns);
      configOptions.autoColumns = false;
    }

    this.tabulatorTable = new Tabulator(this.tableTargets[0], configOptions || defaultConfig);
  }
}
